module.exports = __webpack_public_path__ + "static/img/app_store_badge_mustard.3d3a4e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/app_store_badge_mustard.png
// module id = cp33
// module chunks = 1